<template>
  <table id="TablaModulos" class="table table-bordered table-striped tablaModulos">
    <thead>
      <tr>
        <th width="100">Unidades</th>
        <th>Servicio</th>
        <th
          width="80"
          title="Define si el servicio cubre los costes de implementación de esta oferta"
          v-show="mostrarHoras"
        >
          Imple. Cubierta
        </th>
        <th width="120">Importe</th>
        <th width="80" v-show="mostrarHoras">Horas Consultoria</th>
        <th width="80" v-show="mostrarHoras">Horas Capacitación</th>
        <th width="120" class="acciones" v-if="borrador">Acciones</th>
      </tr>
    </thead>
    <draggable v-model="modulosParaDraggable" tag="tbody" style="user-select: none">
      <tr v-for="(modulo, index) in soloServicios" :key="index" :class="{ quitado: modulo.eliminado }">
        <!-- cantidad -->
        <td class="text-center">
          <b-form-spinbutton v-if="borrador" v-model="modulo.cantidad" size="sm" min="1" max="99999" />
          <span v-else>{{ modulo.cantidad }}</span>
        </td>
        <!-- nombre del modulo -->
        <td>{{ modulo.nombre }}</td>
        <!-- Costes de implementación cubiertos -->
        <td class="text-center" v-show="mostrarHoras">
          <b-form-checkbox
            v-model="modulo.cubreCosteDeImplementacion"
            switch
            :value="true"
            :unchecked-value="false"
            :disabled="!borrador"
          />
        </td>
        <!-- Importe del servicio -->
        <td class="text-center">
          <b-form-input
            v-if="puedeEditarPrecioServicio(modulo)"
            v-model="modulo.precioServicio"
            type="number"
            @input="actualizarPrecioServicio(modulo)"
          />
          <span v-else>{{ modulo.precioServicio }}</span>
        </td>
        <!-- Horas consultoria -->
        <td class="text-center" v-show="mostrarHoras">
          <b-form-input v-if="puedeEditarHoras(modulo)" v-model="modulo.numHorasConsultoria" type="number" />
          <span v-else>{{ modulo.numHorasConsultoria }}</span>
        </td>
        <!-- Horas capacitacion -->
        <td class="text-center" v-show="mostrarHoras">
          <b-form-input v-if="puedeEditarHoras(modulo)" v-model="modulo.numHorasCapacitacion" type="number" />
          <span v-else>{{ modulo.numHorasCapacitacion }}</span>
        </td>
        <!-- acciones -->
        <td v-if="borrador" class="acciones">
          <b-button
            v-if="!modulo.eliminado"
            v-b-tooltip.hover
            size="sm"
            variant="danger"
            class="bbutton-mini"
            @click="eliminarModulo(modulo)"
          >
            <v-icon variant="danger" name="trash-2" width="16" />
            Quitar
          </b-button>
          <b-button
            v-if="modulo.eliminado"
            v-b-tooltip.hover
            size="sm"
            variant="secondary"
            class="bbutton-mini"
            @click="restaurarModulo(modulo)"
          >
            <v-icon variant="secondary" name="corner-up-left" width="16" />
            Restaurar
          </b-button>
        </td>
      </tr>
    </draggable>
    <sin-registros :count="soloServicios.length" :colspan="7" />
  </table>
</template>

<script>
import { mapState, mapWritableState } from "pinia";
import { useSessionStore } from "@/stores/SessionStore";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";

import draggable from "vuedraggable";
import { SAAS, INVERSION } from "@/enums/TipoProyecto";

export default {
  components: {
    draggable,
  },
  computed: {
    ...mapState(useSessionStore, ["esAdmin"]),
    ...mapState(useOfertaFormStore, ["borrador", "oferta", "soloServicios"]),
    mostrarHoras() {
      return this.oferta.tipoProyecto == INVERSION || this.oferta.tipoProyecto == SAAS;
    },
    modulosParaDraggable: {
      get() {
        return this.soloServicios;
      },
      set(value) {
        // Reordenamos los módulos
        value.forEach((modulo, index) => (modulo.ordenModulo = index));

        // Actualizamos el store
        useOfertaFormStore().setOfertaModulos(value);
      },
    },
  },
  data() {
    return {
      dragging: false,
    };
  },
  methods: {
    eliminarModulo(modulo) {
      modulo.eliminado = true;
    },
    restaurarModulo(modulo) {
      modulo.eliminado = false;
    },
    puedeEditarPrecioServicio(modulo) {
      return Boolean(this.borrador && (modulo.permiteCambioPrecio || this.esAdmin));
    },
    puedeEditarHoras(modulo) {
      return Boolean(this.borrador && modulo.permiteCambioHoras);
    },
    actualizarPrecioServicio(modulo) {
      modulo.precioModificado = true;
    },
  },
};
</script>
